module.exports = __webpack_public_path__ + "img/pic01.94a28cb1.png";